import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

const SocialProof = {
  init() {
    new Swiper('.social-proof-carousel', {
      modules: [Navigation],
      slidesPerView: 'auto',
      spaceBetween: 8,
      loop: true,
      grabCursor: true,
      navigation: {
        nextEl: '.ugc-button-next',
        prevEl: '.ugc-button-prev',
      },
      breakpoints: {
        1023: {
          spaceBetween: 16,
        }
      },
    });

    document.querySelectorAll('.video-trigger').forEach(video => {
        video.addEventListener('click', function() {
        if (!document.querySelector('.video-wrapper')) {
            let videoObject = JSON.parse(this.dataset.video);

            const videoBlock = document.createElement('div');
            videoBlock.classList.add('video-wrapper');

            const html = `
            <div class="relative video-wrapper-inner preload">
                <video controls autoplay>
                ${videoObject.sources
                    .map(
                    (source) => `<source src="${source.url}" type="${source.mime_type}" />`
                    )
                    .join('')}
                Your browser does not support the video tag.
                </video>
                <span class="close-video">
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 2L2 12" stroke="white" stroke-width="2" stroke-linecap="square"/>
                    <path d="M2 2L12 12" stroke="white" stroke-width="2" stroke-linecap="square"/>
                </svg>
                </span>
            </div>
            `;

            videoBlock.innerHTML = html;
            document.querySelector('body').appendChild(videoBlock);
            document.querySelector('body').style.overflow = 'hidden';

            const videoElement = videoBlock.querySelector('video');
            videoElement.addEventListener('canplay', function() {
            const videoWrapperInner = videoBlock.querySelector('.video-wrapper-inner');
            videoWrapperInner.classList.remove('preload');
            });

            document.addEventListener('click', function(e) {
            if (e.target.classList.contains('close-video') || e.target.classList.contains('video-wrapper')) {
                videoBlock.remove();
                document.querySelector('body').style.overflow = 'auto';
            }
            });
        }
        });
    });
  }
};

export default SocialProof;